import styles from "./styles.module.css";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";

type IndicatorVariant = "positive" | "negative";

interface IndicatorListProps {
  compositeKey: string;
  title: string;
  items: string[];
  variant: IndicatorVariant;
}

const VariantIcon: React.FC<{ variant: IndicatorVariant }> = ({ variant }) => {
  if (variant === "positive") {
    return <PlusCircleOutlined className={styles.positiveIcon} />;
  }
  return <MinusCircleOutlined className={styles.negativeIcon} />;
};

export default function IndicatorList({ compositeKey, title, items, variant }: IndicatorListProps) {
  return (
    <section className={styles.card}>
      <h3 className={styles.title}>{title}</h3>
      <ul className={styles.list}>
        {items.map((item, idx) => (
          <li key={`${compositeKey}-${variant}-${idx}`} className={styles.item}>
            <VariantIcon variant={variant} />
            <p>{item}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
